import { render, staticRenderFns } from "./PricingFaq.vue?vue&type=template&id=1b903ba0&scoped=true&"
import script from "./PricingFaq.vue?vue&type=script&lang=js&"
export * from "./PricingFaq.vue?vue&type=script&lang=js&"
import style0 from "./PricingFaq.vue?vue&type=style&index=0&id=1b903ba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b903ba0",
  null
  
)

export default component.exports